import { EmptyContent } from '@ztechapps/webui.util'
import { SeeOurProductsButton } from '../../components/SeeOurProductsButton'
import React from 'react'

export const OrderEmptyContent = () => {
  return (
    <EmptyContent
      icon="box"
      message="No recent orders"
      subMessage="You dont have any active or previous orders, browse our products to add one."
      action={<SeeOurProductsButton />}
    />
  )
}
